import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import "../SmcLife/IndexLife.css";
import LifeForm from "./LifeForm";
import axios from "axios";
import WomenTermLife from "./WomenTermLife";
import TwoCroreTerm from "./2CroreTerm";
import HouseWifeTerm from "./HouseWifeTerm";
import LifeTerm from "./LifeTerm";
import CriticalIllness from "./CriticalIllness";
import { ApiSingleton } from "../App";
import * as moment from "moment";
import MouseAwayPopup from "./MouseAwayPop/MouseAwayPopup";

const IndexLife = (props) => {
    const [BtnVal, setBtnVal] = useState("Get Quotes");
    const [IsInitialForm, setInitialForm] = useState(true);
    const [storedRequest, setStoredRequest] = useState(null);
    const [OccupationList, setOccupationList] = useState([]);
    const [EducationList, setEducationList] = useState([]);
    const [userid, setUserID] = useState(0);
    const [IsOpenPopup, setIsOpenPopup] = useState(false);
    const [isPopupShown, setIsPopupShown] = useState(false);
    const [isPopupClosed, setIsPopupClosed] = useState(false);
    const [getMobileNumber, setGetMobileNumber] = useState("")

    let history = useHistory();
    let hasFetched= useRef(false);

    useEffect(() => {
        let request = JSON.parse(sessionStorage.getItem('request'));
        if (request) {
            setStoredRequest(request);
            setInitialForm(false);
        } else {
            setInitialForm(true);
        }
        if (window.localStorage.getItem("token"))
            findUserID();

      
       // callCommonOccupationMaster();

    }, []);


    useEffect(()=>{
        if(!hasFetched.current){
          callMasterAPI();
          hasFetched.current=true;
        }
    },[]);

    const callMasterAPI = async () => {
        const instance = ApiSingleton.getInstance();
        const result = await instance.fetchData();
        setOccupationList(result.OccupationList);
        setEducationList(result.EducationList);
    }

    const findUserID = async () => {
        let user = 0;
        const Model = {
            URL: "GetUserInfo",
            PostString: JSON.stringify({
                Token: JSON.parse(window.localStorage.getItem("token")).token
            })
        }
        axios.post("central/centralcall/CallReqWithHeader", Model)
            .then((res) => {
                setUserID(res.data.userID);
                user = res.data.userID
            });
        return user;
    }
    const submitForm = (req) => {

        let formReq = { ...req };

        if (req !== null && req !== "" && req !== undefined) {
            setBtnVal("Wait...");

            let QuoteReq = {
                EnquiryNo: "",
                SumInsured: props.From === "2cr-term" ? 20000000 : 10000000,
                PayTerm: 15,
                PolicyTerm: "30",
                PremiumFrequency: "Y",
                PremiumPayoutOption: "Lump-Sum",
                FullName: "Test .",
                DoB: req?.DOB.getFullYear() + "-" + ((req?.DOB.getMonth() + 1) < 10 ? ("0" + (req?.DOB.getMonth() + 1)) : (req?.DOB.getMonth() + 1)) + "-" + (req?.DOB.getDate() < 10 ? ("0" + req?.DOB.getDate()) : req?.DOB.getDate()),
                // InsurerAge: req?.Age, //need to remove this
                Gender: req.Gender,
                EmailID: req?.Email,
                MobileNo: req.MobileNo,
                AnnualIncome: req.AnnualIncome,
                Occupation: req.Occupation,
                Education: req.Education,
                PinCode: "110059",
                IsSmoker: req.Smoker === "N" ? false : true,
                CoverTillAge: req.CoverTillAge,
                PlanCode: 0,
                IsAccidentalDeathBenefit: false,
                IsPremiumProtectionBenefit: false,
                IsPremiumWaiverBenefit: false,
                IsAccidentalDisabilityRider: false,
                RiderAccidentalDisabilitySumInsured: 0,
                IsCriticalIllnessRider: props.From.toLowerCase() === "critical-illness" ? true : false,
                RiderCriticalIllnessSumInsured: props.From.toLowerCase() === "critical-illness" ? 500000 : 0,
                IsTerminalIllnessRider: false,
                RiderTerminalIllnessSumInsured: 0,
                IsPersonalAccidentRider: false,
                RiderPersonalAccidentSumInsured: 0,
                IsAccidentalDeathRider: false,
                RiderAccidentalDeathSumInsured: 0,
                IsHospitalCareRider: false,
                RiderHospitalCareSumInsured: 0,
                isAutoPay: props.From.toLowerCase() ==='gen' ? true:false

            };

            let EnqRequest = {
                EnquiryNo: "",
                ClientID: "52",
                UserID: userid,
                MobileNo: req.MobileNo,
                InsurerAge: req.Age,
                Occupation: req.Occupation+"",
                Education: req.Education,
                Gender: req.Gender,
                SmokeStatus: req.Smoker,
                AnnualIncome: Number(req.AnnualIncome),
                SumInsured: props.From.toLowerCase() === "2cr-term" ? 20000000 : 10000000,
                PolicyTerm: 30,
                PolicyType: "Termlife",
                DOB: moment(req?.DOB).format("YYYY-MM-DD"),
                BusinessID: window.localStorage.getItem("BusinessID"),
                IsAccidentalDeathBenefit: false,
                IsPremiumProtectionBenefit: false,
                IsPremiumWaiverBenefit: false,
                IsAccidentalDisabilityRider: false,
                RiderAccidentalDisabilitySumInsured: 0,
                IsCriticalIllnessRider: props.From.toLowerCase() === "critical-illness" ? true : false,
                RiderCriticalIllnessSumInsured: props.From.toLowerCase() === "critical-illness" ? 500000 : 0,
                IsTerminalIllnessRider: false,
                RiderTerminalIllnessSumInsured: 0,
                IsPersonalAccidentRider: false,
                RiderPersonalAccidentSumInsured: 0,
                IsAccidentalDeathRider: false,
                RiderAccidentalDeathSumInsured: 0,
                IsHospitalCareRider: false,
                RiderHospitalCareSumInsured: 0,
                isAutoPay: props.From.toLowerCase() === 'gen' ? true : false
                // Email: req.Email,
                // CoverTillAge: req.CoverTillAge,
            };
            const Model = {
                URL: "AddEnquiry",
                PostString: JSON.stringify(EnqRequest)
            }
            axios.post("central/centralcall/CallReqWithHeader", Model)
                .then((res) => {
                    EnqRequest.EnquiryNo = res.data.Data.EnquiryNo;
                    QuoteReq.EnquiryNo = res.data.Data.EnquiryNo;
                    let InsurerList = res.data.Data.InsurerList;
                    history.push({
                        pathname: "/SmcLifeQuote",
                        state: { Req: EnqRequest, QuoteReq, InsurerList, formReq: formReq, isHousewife: props.From.toLowerCase() === "women-term",  allTermLifePath:props.From  },
                    });
                })
                .catch((err) => {
                    setInitialForm(false);
                    setBtnVal("Get Quotes");
                });
        } else {
            setBtnVal("Get Quotes");
            setInitialForm(true);
        }
    };
        
    
    useEffect(() => {
        sessionStorage.removeItem('response');
        sessionStorage.removeItem('benefitCount');
        sessionStorage.removeItem('riderCount');
        sessionStorage.removeItem('request');
        sessionStorage.removeItem('proposal');
    }, []);

    useEffect(() => {
        if (!isPopupShown && !isPopupClosed) {
            const handleMouseLeave = (event) => {
                if (event.clientY <= 10) {
                    setIsOpenPopup(true);
                    setIsPopupShown(true);
                    document.removeEventListener("mouseleave", handleMouseLeave);
                }
            };

            document.addEventListener("mouseleave", handleMouseLeave);
            return () => {
                document.removeEventListener("mouseleave", handleMouseLeave);
            };
        }
    }, [isPopupShown, isPopupClosed]);

    const handleClosePopup = () => {
        setIsOpenPopup(false);
        setIsPopupClosed(true);
    };

  

    const handleGetMobile = (param) => {
        setGetMobileNumber(param)
    }

    return (

        <div className="IndexLifeMainPage">
            <div className="space">
                <div className="container">
                    <div className="Life_Index_For_Box">
                        <div className="row">
                            {props.From === "women-term" ? <WomenTermLife {...props} /> : props.From === "housewife-term" ? <HouseWifeTerm {...props} /> : props.From === "2cr-term" ? <TwoCroreTerm {...props} /> : props.From.toLowerCase() === "critical-illness" ? <CriticalIllness {...props} /> : <LifeTerm {...props} />}
                            <div className="col-lg-5 landing-area">
                                <div className="">
                                    <LifeForm
                                        submitForm={submitForm}
                                        BtnVal={BtnVal}
                                        IsInitialForm={IsInitialForm}
                                        setInitialForm={(data) => setInitialForm(data)}
                                        request={storedRequest}
                                        InsuranceType={props.From}
                                        OccupationList={OccupationList ?? []}
                                        EducationList={EducationList ?? []}
                                        getMobileNumber={getMobileNumber}
                                        onGetMobileChange={handleGetMobile }
                                    />
                                </div>
                            </div>
                            {IsOpenPopup && (
                                <MouseAwayPopup onClose={handleClosePopup} IsMobileNumber={getMobileNumber} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};
export default IndexLife;
